import {AppForm} from '../../../../../../../common/forms/app.form';
import {inject, Injectable, signal, Signal, WritableSignal} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {CustomValidator, fromToDate} from '../../../../../../../common/forms/custom.validators';
import {ApplicationCommonService, PorIdApplicationItem} from '../../../../../../../services/application.common.service';
import {ApplicationAppEntityApplicationRead, ApplicationAppEntityApplicationWrite} from '../../../../../../../openapi';
import {toSignal} from '@angular/core/rxjs-interop';
import {catchError, of, tap} from 'rxjs';

export type ProjectTypeItem = 'Stałej' | 'Czasowej' | string;

@Injectable()
export class TrafficOrganizationProjectForm extends AppForm {

  public loading: boolean = true;

  private applicationService: ApplicationCommonService = inject(ApplicationCommonService);

  private porIdApplications: Signal<PorIdApplicationItem[] | undefined> = toSignal(
    this.applicationService.loadPorIdApplications()
      .pipe(
        tap(v => this.loading = false),
        catchError(v => {
          this.loading = false;
          return of([]);
        })
      )
  );

  public porIdOptions: WritableSignal<PorIdApplicationItem[]> = signal([]);

  constructor() {
    super({
      projectType: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      porId: new FormControl('', [Validators.maxLength(255)]),
      trafficOrganizationDescription: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(5000)]
      }),
      startDate: new FormControl(
        null,
        [Validators.required, CustomValidator.minDate(new Date())]
      )
    }, {
      validators: [fromToDate('startDate', 'endDate')]
    });
  }

  public get porId(): FormControl {
    return this.get('porId') as FormControl;
  }

  public projectTypeChange(v: ProjectTypeItem): void {
    this.porId.setValue('');
    if (!v) {
      this.porIdOptions.set([]);
    } else {
      this.porIdOptions.set(
        this.porIdApplications()?.filter(item => item.projectType === v) || []
      );
    }
    if (v === 'Czasowej') {
      this.addControl('endDate', new FormControl(null, Validators.required));
    } else {
      this.removeControl('endDate');
    }
  }

  public get endDate(): FormControl | null {
    return this.get('endDate') as FormControl | null;
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    let value = this.value;
    delete value.parcels;
    return value;
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead): void {
    super.patchFormValues(value);
    this.projectTypeChange(value?.projectType || '');
    this.porId.setValue(value?.porId || '');

    this.endDate?.setValue(value?.endDate);
  }
}
